import React from 'react'
import { Auth } from 'aws-amplify'
import { Button, Col, FormControl, FormGroup, FormLabel, Modal, Row } from 'react-bootstrap'
import * as AppDefinitions from '../../App.d'
import LoadingImage from '../../images/xero-logo.svg'
import * as Request from '../../utilities/request'
import { MessageAction } from '../../components/ui/messages/message'
import { NavigateFunction } from 'react-router-dom'
import { refreshSession } from '../../utilities/login'

export interface HandleEventPopUpProps {
	popUpEventType: 'Create' | 'Join' | ''
	handleClose: () => void
	show: boolean
	updateMessages: (message: MessageAction) => void
	appState: AppDefinitions.AppState
	updateAppState?: React.Dispatch<AppDefinitions.AppStateAction>
	navigate: NavigateFunction
}

const getInitialAccountName = (appState: AppDefinitions.AppState) =>
	`${appState.authState.attributes?.given_name} ${appState.authState.attributes?.family_name} Account`

const HandleEvent = (props: HandleEventPopUpProps) => {
	const [isSubmitting, updateIsSubmitting] = React.useState<boolean>(false)
	const [accountName, updateAccountName] = React.useState<string>(getInitialAccountName(props.appState))
	const goBackToLogin = () => {
		Auth.signOut()
			.then(() => {
				window.location.href = '/'
			})
			.catch((err: Error) => console.log(err))
	}
	const handleCreation = async () => {
		// start account creation for this user
		const values = {
			name: accountName,
			ownerUserID: props.appState.authState.attributes!['custom:userId'],
			createUserID: props.appState.authState.attributes!['custom:userId'],
			modifiedUserID: props.appState.authState.attributes!['custom:userId'],
		}
		const req = await Request.post(`account/user`, values)
		if (req.data.success) {
			props.updateMessages({
				type: 'add',
				data: {
					severity: 'success',
					message: 'Successfully created account',
					timeout: 3000,
					dismissible: true,
				},
			})
			localStorage.setItem('onBoardingStep', '0')
			props.updateAppState!({
				state: 'newAccountConfirmed',
				data: {
					accounts: req.data.accounts,
					permission: {
						roleID: req.data.accounts[0].billyPermissionID || null,
					},
					attributes: {
						...props.appState.authState.attributes,
						'custom:currentAccountId': req.data.accounts[0].accountID,
						'custom:userAccountId': req.data.accounts[0].userAccountID,
					},
				},
			})
			await refreshSession()
			props.navigate('/onboarding')
		}
	}
	return (
		<Modal show={props.show} aria-labelledby="modal" centered onHide={props.handleClose}>
			<Modal.Header>
				<Modal.Title>{props.popUpEventType === 'Join' ? 'Join Existing Account' : 'Create Account'}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormGroup>
					<>
						{props.popUpEventType === 'Join' ? (
							<Row style={{ paddingBottom: '10px' }}>
								<Col>
									<p>
										To join an existing account, please contact the person in charge of your organisation&apos;s account and ask them to
										invite you in!
									</p>
									<p>
										Don&apos;t know who&apos;s in charge? <a href="mailto:support@finlert.com">Reach out</a> and we can help you.
									</p>
								</Col>
							</Row>
						) : (
							<FormGroup as={Row}>
								<FormLabel column sm={4}>
									Account Name
								</FormLabel>
								<Col sm="6">
									<FormControl
										type="text"
										id={'name'}
										name="name"
										placeholder="Account Name"
										onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
											const value = event.target.value
											updateAccountName(value)
										}}
										value={accountName}
									/>
								</Col>
							</FormGroup>
						)}
					</>
					{!isSubmitting ? (
						props.popUpEventType === 'Join' ? (
							<Button variant={'success'} disabled={isSubmitting} style={{ marginRight: '15px' }} onClick={goBackToLogin}>
								Ok
							</Button>
						) : (
							<>
								<Button
									variant={'success'}
									disabled={isSubmitting}
									style={{ marginRight: '15px' }}
									onClick={() => {
										handleCreation()
										updateIsSubmitting(true)
									}}
								>
									Create
								</Button>
								<Button variant={'secondary'} onClick={props.handleClose}>
									Cancel
								</Button>
							</>
						)
					) : (
						<img src={LoadingImage} alt="Loading ..." style={{ width: '10%' }} />
					)}
				</FormGroup>
			</Modal.Body>
		</Modal>
	)
}

export default HandleEvent
